import { Modal } from '@automata/ui';

import { AuthenticationChecker } from './AuthenticationChecker';
import { Form } from './Form';
import { CommonProps } from './types';

export const ResourceActionsModal = (props: CommonProps) => {
  const { open, onClose, resourceAction, resourceType } = props;

  return (
    <AuthenticationChecker {...props}>
      <Modal
        open={open}
        onClose={onClose}
        title={`${resourceAction} ${resourceType}`}
      >
        <Form {...props} />
      </Modal>
    </AuthenticationChecker>
  );
};
